import { useTranslation } from 'hooks/use-translation';
import React, { FC, useMemo } from 'react';
import styles from './styles.scss';
import { useModalContext } from 'hooks/useModalContext';
import useResizeObserver from 'hooks/use-resize-observer';
import AcSwipe from 'ac-components/ac-swiper';
import classnames from 'classnames';

type IProps = {
	onClick?: () => void;
};

const StressSection: FC<IProps> = (props) => {
	const { setTrigger, isShow, setHeader, setClassName, extraObject, setExtraObject } = useModalContext();
	const { list, transData } = useTranslation('home.stress');
	const { width } = useResizeObserver();

	const renderItem = useMemo(() => {
		return list?.map((item: string, index: React.Key | undefined) => {
			return (
				<div className={styles['item']} key={index}>
					<span>{item}</span>
				</div>
			);
		});
	}, [list]);

	return (
		<section className={styles['ac-stress']} id="stress">
			<div className={styles['ac-stress-container']}>
				<h3 className={styles['stress-title']}>{transData.title}</h3>

				{width >= 1192 && (<div className={styles['stress-box']}>{renderItem}</div>)}
				{width < 1192 && (
					<AcSwipe
						className={classnames(styles['ac-stress-banner'], 'ac-stress-banner')}
						loop
						spaceBetween={width >= 768 ? 70 : 30}
						pagination={{ clickable: true }}
						autoplay={{
							delay: 5000,
							disableOnInteraction: false,
						}}
						slidesPerGroup={width >= 768 ? 3 : 2}
						loopFillGroupWithBlank={width >= 768}
						slidesPerView={width >= 768 ? 3 : 2}>
						{renderItem}
					</AcSwipe>
				)}
			</div>
		</section>
	);
};

export default StressSection;
